import { createTheme, ThemeOptions } from '@mui/material';

export const baseTheme = (theme: ThemeOptions) =>
  createTheme({
    typography: {
      fontFamily: 'Roboto, sans-serif',
      h1: {
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '30px',
        lineHeight: '36px',
        color: theme?.palette?.text!.primary,
      },
      h2: {
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '30px',
        lineHeight: '36px',
        color: theme?.palette?.text!.primary,
      },
      h3: {
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '1.25rem',
        lineHeight: '1.75rem',
        color: theme?.palette?.text!.primary,
      },
      h4: {
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '1.125rem',
        lineHeight: '1.75rem',
        color: theme?.palette?.text!.primary,
      },
      h5: {
        fontStyle: 'normal',
        fontWeight: 500,
        fontSize: '16px',
        lineHeight: '24px',
        letterSpacing: '0.13px',
        color: theme?.palette?.text!.primary,
      },
      h6: {
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '20px',
        lineHeight: '28px',
        letterSpacing: '0.16px',
        color: theme?.palette?.text!.primary,
      },
      body1: {
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '1rem',
        lineHeight: '1.5rem',
        letterSpacing: '0.128px',
        color: theme?.palette?.text!.primary,
      },
      body2: {
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '13px',
        lineHeight: '16px',
        letterSpacing: '0.104px',
        color: theme?.palette?.text!.primary,
      },
      subtitle1: {
        fontWeight: 400,
        fontSize: '14px',
        lineHeight: '1.25rem',
        color: theme?.palette?.text!.secondary,
      },
      subtitle2: {
        fontWeight: 400,
        fontSize: '12px',
        lineHeight: '1.167em',
        color: theme?.palette?.text!.primary,
      },
      button: {
        fontWeight: 500,
        fontSize: '0.875rem',
        lineHeight: '1.05rem',
        letterSpacing: '0.053.rem',
        textTransform: 'uppercase',
        color: theme?.palette?.text!.primary,
      },
      caption: {
        fontStyle: 'normal',
        fontWeight: 500,
        fontSize: '.75rem',
        lineHeight: '1rem',
        letterSpacing: '0.104px',
        color: theme?.palette?.text!.primary,
      },
    },
  });
